// src/features/owner/sections/analytics/UserStatisticsSection.tsx
import { AnalyticsSection } from './AnalyticsSection';
export const UserStatisticsSection = () => <AnalyticsSection kind="user-statistics" />;
